export default function average(enumerable, selector) {
    return enumerable.sum(selector) / enumerable.count();
}
